import React, { useState } from 'react';

export default function AddParameterModal({ existingParameters, onClose, onAdd }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const parameter = name.trim().toUpperCase().replace(/\s+/g, '_');
    if (!/^[A-Z][A-Z0-9_]*$/.test(parameter)) {
      setError('Use letters, numbers and underscores only, starting with a letter.');
      return;
    }
    if (existingParameters.includes(parameter)) {
      setError(`{${parameter}} is already in the question template.`);
      return;
    }
    onAdd(parameter);
  };

  return (
    <div className="admin-confirm" role="dialog" aria-modal="true" aria-labelledby="add-parameter-title">
      <div className="admin-confirm__backdrop" onClick={onClose} />
      <form className="admin-confirm__box admin-add-param-modal" onSubmit={submit}>
        <h2 id="add-parameter-title">Add parameter</h2>
        <p>Add a business parameter. Its placeholder will be added to the question template automatically.</p>
        <label className="admin-form-label" htmlFor="parameter-name">Parameter name</label>
        <input
          id="parameter-name"
          className={`admin-form-input${error ? ' is-error' : ''}`}
          value={name}
          onChange={(event) => { setName(event.target.value); setError(''); }}
          placeholder="e.g. PRODUCT_NAME"
          autoFocus
        />
        {error && <div className="admin-form-error">{error}</div>}
        <div className="admin-confirm__actions">
          <button type="button" className="admin-btn admin-btn--ghost" onClick={onClose}>Cancel</button>
          <button type="submit" className="admin-btn admin-btn--primary">Add Parameter</button>
        </div>
      </form>
    </div>
  );
}
